import { type SxProps, type Theme } from '@mui/material'
import { tableStyles } from '../../../customComponents/dataTable/tableStyles'

export const styles = {
  sortableHeadCell: {
    ...tableStyles.headCell,
    ...tableStyles.sortableHeadCell
  } satisfies SxProps<Theme>,
  submitterName: {
    fontWeight: 700,
    color: 'var(--grey-900)'
  } satisfies SxProps<Theme>,
  submitterEmail: {
    display: 'block',
    color: 'var(--grey-500)'
  } satisfies SxProps<Theme>
}
